import { render, staticRenderFns } from "./PolkaDotBackground.vue?vue&type=template&id=4c66118b&scoped=true"
import script from "./PolkaDotBackground.vue?vue&type=script&lang=js"
export * from "./PolkaDotBackground.vue?vue&type=script&lang=js"
import style0 from "./PolkaDotBackground.vue?vue&type=style&index=0&id=4c66118b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c66118b",
  null
  
)

export default component.exports